import { lazy, Suspense, type ComponentType } from 'react'

import { LoadingState, Screen } from '~/shared/ui'

type PageModule = { default: ComponentType }

/**
 * Оборачивает React.lazy() в Suspense со скелетоном вместо спиннера
 * (спека 01 §7: загрузка — скелетоны по форме контента).
 */
export function lazyPage(factory: () => Promise<PageModule>) {
  const LazyComponent = lazy(factory)

  return function LazyPage() {
    return (
      <Suspense
        fallback={
          <Screen>
            <LoadingState size='L' />
          </Screen>
        }
      >
        <LazyComponent />
      </Suspense>
    )
  }
}
